const cartAf = {
  title: 'زما د پیرود کڅوړه',
  clearAll: 'ټول پاک کول',
  itemsInBag: (n) => `ستاسو په کڅوړه کې ${n} توکي`,
  sectionCartItems: 'ستاسو په کڅوړه کې توکي',
  continueShopping: 'د پیرود دوام',
  orderSummary: 'د امر لنډیز',
  subtotal: 'فرعي مجموعه',
  delivery: 'د لېږد چارج',
  free: 'وړیا',
  discount: 'تخفیف',
  total: 'مجموعه',
  couponPlaceholder: 'د کوپون کوډ ولیکئ',
  applyCoupon: 'کوپون پلي کول',
  proceedCheckout: 'د تادیه ته تلل',
  trust: {
    securePayment: '100% سالم تادیه',
    fastDelivery: 'ګړندي لېږد',
    cod: 'د لېږد په وخت کې پیسې'
  },
  empty: {
    title: 'ستاسو کڅوړه تشه ده',
    subtitle: 'دا ښکاري چې تاسو تر اوسه هیڅ توکي اضافه نه کړي.\nزموږ د ښکلې محصولاتو ته وګورئ او د پیرود پیل کړئ!',
    cta: 'د پیرود پیل'
  },
  item: {
    inStock: 'په ګودام کې',
    removed: 'توکی له کڅوړې څخه لرې شو'
  },
  cleared: 'ټول توکي له کڅوړې څخه لرې شول'
};

export default cartAf;
